import DOMHelper from '../reflection/DOMHelper';
import TutorialTimer from '../tutorials/TutorialTimer';
import TutorialMessage from '../tutorials/TutorialMessage';
import eventEnable from '../core/eventEnable';
export default class Tutorials{
	static get showing(){
		return Tutorials._showing;
	}
	static set showing(value){
		Tutorials._showing = value;
		if(!value){
			for(var tutorialMessage of Array.from(Tutorials._showingTutorialMessages)){
				tutorialMessage.dispose();
			}
		}
	}
	static dispatchUpdate(){
		Tutorials.dispatchEvent({type:'update'});
	}
	static get showStep2(){
		return Tutorials._showStep2;
	}
	static _updateShowStep2(){
		Tutorials._showStep2 = Tutorials.hasClickedBirdsEyeViewLeftOrRightButton&&Tutorials.hasClickedFilter;
		if(Tutorials._showStep2){
			Tutorials._hasDoneShowStep2=true;
			Tutorials.dispatchEvent({type:'update'});
		}
	}
	
	static get showStep3(){
		return Tutorials._showStep3;
	}
	static _updateShowStep3(){
		Tutorials._showStep3 = Tutorials.hasExpandedPlotMenu&& Tutorials._hasDoneShowStep2;
		if(Tutorials._showStep3){
			Tutorials._hasDoneShowStep3=true;
			Tutorials.dispatchEvent({type:'update'});
		}
	}
	static get showStep3_1(){
		return Tutorials._showStep3_1;
	}
	static _updateShowStep3_1(){
		Tutorials._showStep3_1= Tutorials.hasClickedPlotMenuGallery&&Tutorials._hasDoneShowStep3;
		if(Tutorials._showStep3_1)
			Tutorials.dispatchEvent({type:'update'});
	}
	static get showStep3_2(){
		return Tutorials._showStep3_2;
	}
	static _updateShowStep3_2(){
		Tutorials._showStep3_2= Tutorials.hasClickedPlotMenuFloorPlans&& Tutorials._hasDoneShowStep3
		if(Tutorials._showStep3_2)
			Tutorials.dispatchEvent({type:'update'});
	}
	static get showStep4(){
		return Tutorials._showStep4;
	}
	static _updateShowStep4(){
		Tutorials._showStep4 = Tutorials.hasClickedPlotMenuFavourites;
		if(Tutorials._showStep4)
			Tutorials.dispatchEvent({type:'update'});
	}
	static get showStep5(){
		return Tutorials._showStep5;
	}
	static _updateShowStep5(){
		Tutorials._showStep5 = Tutorials.hasClickedFavourites;
		if(Tutorials._showStep5)
			Tutorials.dispatchEvent({type:'update'});
	}
	static get showStep6(){
		return Tutorials._showStep6;
	}
	static _updateShowStep6(){
		Tutorials._showStep6 = Tutorials.hasClickedGenerateBrochureForFavourites||Tutorials.hasClickedCompareFavourites;
		if(Tutorials._showStep6)
			Tutorials.dispatchEvent({type:'update'});
	}
	static get showStep7(){
		return Tutorials._showStep7&&(!Tutorials.showStep8);
	}
	static _updateShowStep7(){
		Tutorials._showStep7 = Tutorials.haveBeenToOutside360;
		if(Tutorials._showStep7){
			Tutorials.hasExpandedPlotMenu=false;
			Tutorials.dispatchEvent({type:'update'});
		}
	}
	static get showStep8(){
		return Tutorials._showStep8;
	}
	static _updateShowStep8(){
		Tutorials._showStep8 = Tutorials.hasClickedGoToOutside360;
		if(Tutorials._showStep8){
			Tutorials.dispatchEvent({type:'update'});
		}
	}
	static get hasClickedPlotMenuFavourites(){
		return Tutorials._hasClickedPlotMenuFavourites;
	}
	static set hasClickedPlotMenuFavourites(value){
		Tutorials._hasClickedPlotMenuFavourites = value;
		Tutorials._updateShowStep4();
	}
	static get hasClickedPlotMenuGallery(){
		return Tutorials._hasClickedPlotMenuGallery;
	}
	static set hasClickedPlotMenuGallery(value){
		Tutorials._hasClickedPlotMenuGallery = value;
		Tutorials._updateShowStep3_1();
	}
	static get haveBeenToOutside360(){
		return Tutorials._haveBeenToOutside360;
	}
	static set haveBeenToOutside360(value){
		Tutorials._haveBeenToOutside360 = value;
		Tutorials._updateShowStep7();
	}
	static get hasClickedPlotMenuFloorPlans(){
		return Tutorials._hasClickedPlotMenuFloorPlans;
	}
	static set hasClickedPlotMenuFloorPlans(value){
		Tutorials._hasClickedPlotMenuFloorPlans = value;
		Tutorials._updateShowStep3_2();
	}
	static get hasClickedFavourites(){
		return Tutorials._hasClickedFavourites;
	}
	static set hasClickedFavourites(value){
		Tutorials._hasClickedFavourites = value;
		Tutorials._updateShowStep5();
	}
	static get hasClickedMenuBarFavourite(){
		return Tutorials._hasClickedMenuBarFavourite;
	}
	static set hasClickedMenuBarFavourite(value){
		Tutorials._hasClickedMenuBarFavourite = value;
		 Tutorials._updateShowStep4();
	}
	static get hasClickedGenerateBrochureForFavourites(){
		return Tutorials._hasClickedGenerateBrochureForFavourites;
	}
	static set hasClickedGenerateBrochureForFavourites(value){
		Tutorials._hasClickedGenerateBrochureForFavourites = value;
		 Tutorials._updateShowStep6();
	}
	static get doneWithMoveAroundOutside360Message(){
		return Tutorials._doneWithMoveAroundOutside360Message;
	}
	static set doneWithMoveAroundOutside360Message(value){
		Tutorials._doneWithMoveAroundOutside360Message = value;
	}
	static get hasClickedBirdsEyeViewLeftOrRightButton(){
		return Tutorials._hasClickedBirdsEyeViewLeftOrRightButton;
	}
	static set hasClickedBirdsEyeViewLeftOrRightButton(value){
		Tutorials._hasClickedBirdsEyeViewLeftOrRightButton = value;
		Tutorials._updateShowStep2();
	}
	static get hasClickedCompareFavourites(){
		return Tutorials._hasClickedCompareFavourites;
	}
	static set hasClickedCompareFavourites(value){
		Tutorials._hasClickedCompareFavourites = value;
		Tutorials._updateShowStep6();
	}
	static get canShowReturnToAerialViewMessage(){
		return Tutorials._canShowReturnToAerialViewMessage;
	}
	static set canShowReturnToAerialViewMessage(value){
		Tutorials._canShowReturnToAerialViewMessage = value;
	}
	static get hasClickedGoToOutside360(){
		return Tutorials._hasClickedGoToOutside360;
	}
	static set hasClickedGoToOutside360(value){
		Tutorials._hasClickedGoToOutside360 = value;
		Tutorials._updateShowStep8();
	}
	static get hasClickedFilter(){
		return Tutorials._hasClickedFilter;
	}
	static set hasClickedFilter(value){
		Tutorials._hasClickedFilter = value;
		Tutorials._updateShowStep2();
	}
	static get hasExpandedPlotMenu(){
		return Tutorials._hasExpandedPlotMenu;
	}
	static set hasExpandedPlotMenu(value){
		Tutorials._hasExpandedPlotMenu = value;
		Tutorials._updateShowStep3();
	}
	static set nOutside360HotspotsClicked(value){
		if(value>=3){
			Tutorials._canShowReturnToAerialViewMessage = true;
		}
		if(value>=2){
			Tutorials._doneWithMoveAroundOutside360Message=true
		}
		Tutorials._nOutside360HotspotsClicked=value;
		Tutorials.dispatchEvent({type:'nOutside360HotspotsClickedChanged', value});
	}
	static get nOutside360HotspotsClicked(){
		return Tutorials._nOutside360HotspotsClicked;
	}
	
	static addShowingTutorialMessage(tutorialMessage){
		let handleDispose;
		handleDispose = ()=>{
			tutorialMessage.removeEventListener('dispose', handleDispose);
			const index = Tutorials._showingTutorialMessages.indexOf(tutorialMessage);
			if(index<0)return;
			Tutorials._showingTutorialMessages.splice(index, 1);
		};
		tutorialMessage.addEventListener('dispose', handleDispose);
		Tutorials._showingTutorialMessages.push(tutorialMessage);
	}
	static closeAll(){
			Tutorials._showing = false;
			try{
				Tutorials.dispatchUpdate();
			}catch(err){}
	}
}
eventEnable(Tutorials);
Tutorials._nOutside360HotspotsClicked=0;
Tutorials._showing= false;
Tutorials._showingTutorialMessages = [];
window.Tutorials = Tutorials;